module.exports = __webpack_public_path__ + "static/event1010-e643fca5fb3053486a4c721f7f3b93af.jpeg";